<div class="ngx-bottom-nav-button" [routerLink]="routerLink()">
  <ng-content select="[ngxBottomNavIcon]"></ng-content>
  <div class="label">{{ label() }}</div>
</div>
